import styled from 'styled-components';

export const Text = styled.p`
  max-width: 259px;
  color: #495057;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 19.6px */
  margin-top: 8px;
  text-align: left;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;

  button {
    margin-left: 8px;
    width: 100px;

    &.text-danger {
      background: #fa5252;
      color: #fff;
    }

    &.text-secondary {
      color: #495057;
      border: 1px solid #ced4da;
    }
  }
`;
